export function checkWebGPUSupport(): void {
  if (!navigator.gpu) {
    throw new Error(
      'WebGPU is not supported in this browser.\n' +
      'Try Chrome 113+, Edge 113+, or Firefox Nightly with WebGPU enabled.',
    );
  }
}
